<template>
  <div class="h-screen">
    <!-- <a-menu class="h-full" :default-selected-keys="['1']" :default-open-keys="['sub1']" mode="inline" theme="dark" :inline-collapsed="collapsed"> -->
    <!-- <a-menu class="h-full" :default-selected-keys="['1']" mode="inline" theme="dark" :inline-collapsed="collapsed"> -->
    <a-menu class="relative custom-menu font-medium h-full" :selected-keys="[selectedKey]" mode="inline" theme="dark" :inline-collapsed="collapsed">
      <a-button type="primary" @click="toggleCollapsed">
        <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
      </a-button>
      <a-menu-item v-for="item in resolvedMenuItems" :key="item.key">
        <router-link :to="item.path">
          <a-icon :type="item.icon" />
          <span>{{ item.label }}</span>
        </router-link>
      </a-menu-item>
      <!-- <button class="text-white py-2 px-4 text-lg font-black rounded-2xl bg-blue-500">登出</button> -->
      <a-button @click="logout()" style="position: absolute; bottom: 0; left: 0" type="danger" block>登出</a-button>
    </a-menu>
  </div>
</template>

<script>
import { activeAppVariant } from '../appVariant'

export default {
  props: {
    menuItems: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      // API 路徑配置
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,

      collapsed: false,
      selectedKey: ''
    }
  },
  components: {},
  computed: {
    resolvedMenuItems () {
      return this.menuItems.length > 0 ? this.menuItems : activeAppVariant.menuItems
    },
    routeKeyMap () {
      return this.resolvedMenuItems.reduce((map, item) => {
        map[item.path] = item.key
        return map
      }, {})
    },
    defaultSelectedKey () {
      return this.resolvedMenuItems[0] ? this.resolvedMenuItems[0].key : ''
    }
  },
  watch: {
    $route (to) {
      // 根據當前路由更新 selectedKey
      this.selectedKey = this.routeKeyMap[to.path] || this.defaultSelectedKey
    },
    resolvedMenuItems: {
      handler () {
        this.selectedKey = this.routeKeyMap[this.$route.path] || this.defaultSelectedKey
      },
      immediate: true
    }
  },
  methods: {
    toggleCollapsed () {
      this.collapsed = !this.collapsed
      this.$emit('collapsed-change', this.collapsed)
    },
    LogOut () {
      this.$router.push({ path: '/LogIn' })
    },
    // 🔧 修改後的前端登出方法
    async logout () {
      try {
        // 🆕 改為呼叫你的後端代理 API
        const response = await this.axios.post(
          `${this.baseURL}${this.basePort}/auth/logout`,
          {},
          {
            // 🆕 如果你的系統有 token，可以加在 headers
            headers: {
              Authorization: `Bearer ${this.$store.state.token}`
            }
          }
        )

        console.log('✅ 登出API成功:', response.data)

        // 清除本地登入狀態
        this.$store.dispatch('logout')
        // 跳轉到登入頁
        this.$router.push({ path: '/LogIn' })
        this.$message.success('登出成功！')
      } catch (error) {
        console.error('登出API失敗，但仍清除本地狀態:', error)

        // ✅ 即使API失敗也要清除本地狀態（保持原有邏輯）
        this.$store.dispatch('logout')
        this.$router.push({ path: '/LogIn' })

        // 🆕 稍微優化錯誤提示
        this.$message.warning('登出完成（服務連線異常）')
      }
    }
  }
}
</script>
<style lang="css">
.custom-menu .ant-menu-item,
.custom-menu .ant-menu-item a {
  font-size: 18px; /* 增大文字大小 */
}

.custom-menu .ant-menu-item .anticon {
  font-size: 18px; /* 增大图标大小 */
  vertical-align: middle;
}

.custom-menu .ant-menu-item span {
  vertical-align: middle;
  line-height: 18px;
}
.aa {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
